import React from 'react';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import CampaignsTableRow from './CampaignsTableRow';

export default class CampaignsTable extends React.Component {

    getTableRow(campaign) {
        return <CampaignsTableRow key={campaign.campaignId} campaign={campaign} locations={this.props.locations} />;
    }

    render() {
        return <PaginatedTable
            name="campaigns"
            page={this.props.page}
            totalCount={this.props.data.totalCount}
            resultsView={this.props.resultsView}
            sort={this.props.sort}
            loading={this.props.loading}
            success={this.props.success}
            renderRow={this.getTableRow.bind(this)}
            columns={[
                { id: 'status', title: 'Status', sortable: true },
                { id: 'campaignName', title: 'Campaign Name', sortable: false },
                { id: 'date', title: 'Date', sortable: false },
                { id: 'recipients', title: 'Recipients', sortable: false },
                { id: 'allocatedFunds', title: 'Campaign Total (to date)', sortable: false }]}
            records={this.props.data.records || []}
            sortData={this.props.updateTable}
            changeDataView={this.props.updateTable}
            loadData={this.props.getCampaigns} />
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaigns/CampaignsTable.jsx